'use client';

import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import { Download } from 'lucide-react';

const SalesAreaChart = dynamic(() => import('./SalesAreaChart'), { ssr: false });

const periodFilters = [
  { id: 'filter-today', label: 'Today' },
  { id: 'filter-week', label: '7 Days' },
  { id: 'filter-month', label: '30 Days' },
  { id: 'filter-year', label: 'Year' },
  { id: 'filter-custom', label: 'Custom' },
];

export default function SalesChartSection() {
  const [activePeriod, setActivePeriod] = useState('filter-month');
  const [comparePrev, setComparePrev] = useState(false);

  return (
    <div className="card p-5 h-full">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div>
          <h2 className="text-base font-semibold text-foreground">Sales Trend</h2>
          <p className="text-xs text-muted-foreground mt-0.5">Revenue over selected period (PKR)</p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {/* Period filters */}
          <div className="flex bg-muted rounded-lg p-0.5 gap-0.5">
            {periodFilters?.map((f) => (
              <button
                key={f?.id}
                onClick={() => setActivePeriod(f?.id)}
                className={`px-2.5 py-1 rounded-md text-xs font-medium transition-all duration-150 ${
                  activePeriod === f?.id
                    ? 'bg-card text-primary shadow-sm font-semibold'
                    : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                {f?.label}
              </button>
            ))}
          </div>

          {/* Compare toggle */}
          <button
            onClick={() => setComparePrev(!comparePrev)}
            className={`flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-medium border transition-all duration-150 ${
              comparePrev
                ? 'bg-primary text-white border-primary' :'border-border text-muted-foreground hover:border-primary hover:text-primary'
            }`}
          >
            Compare
          </button>

          <button className="btn-ghost p-1.5" title="Export chart">
            <Download size={14} />
          </button>
        </div>
      </div>
      {/* Summary row */}
      <div className="grid grid-cols-3 gap-3 mb-4">
        {[
          { id: 'sum-revenue', label: 'Total Revenue', value: 'PKR 3,24,800', change: '+8.1%', up: true },
          { id: 'sum-orders', label: 'Orders', value: '412', change: '+5.3%', up: true },
          { id: 'sum-avg', label: 'Avg Order Value', value: 'PKR 788', change: '-2.1%', up: false },
        ]?.map((s) => (
          <div key={s?.id} className="bg-muted/50 rounded-lg p-3">
            <p className="text-xs text-muted-foreground mb-1">{s?.label}</p>
            <p className="text-sm font-bold tabular-nums">{s?.value}</p>
            <p className={`text-xs font-semibold mt-0.5 ${s?.up ? 'text-success' : 'text-danger'}`}>
              {s?.change}
            </p>
          </div>
        ))}
      </div>
      {/* Chart */}
      <div className="h-52">
        <SalesAreaChart comparePrev={comparePrev} />
      </div>
    </div>
  );
}